// apps/provider/src/hooks/useRestrictedLocationId.js
// The ONLY location value that belongs in calendarStore fetch params: the
// permission boundary for location-restricted users. Everything else about
// location is a client-side view filter (like provider selection), so Home
// and the calendar share one cache key and never thrash each other's data.

import { useMemo } from 'react';
import { usePermissionFilters } from './usePermissionFilters';

export function useRestrictedLocationId() {
  const { isLocationRestricted, getLocationFilter } = usePermissionFilters();

  return useMemo(() => {
    if (!isLocationRestricted) return null;
    return getLocationFilter().location_id || null;
  }, [isLocationRestricted, getLocationFilter]);
}
